/**
 * Horizon 4.0 runtime spine — keep small, defer-loaded, extend via register().
 */
(function () {
  'use strict';

  var Horizon = (window.Horizon = window.Horizon || {});
  var modules = {};

  Horizon.register = function (name, factory) {
    modules[name] = factory;
  };

  Horizon.boot = function (name, options) {
    if (!modules[name]) return null;
    return modules[name](options || {});
  };

  Horizon.ready = function (fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  /**
   * Load a deferred script once (search, maps, configurator bridges).
   */
  var loading = {};
  Horizon.loadScript = function (src) {
    if (!src) return Promise.reject(new Error('missing src'));
    if (loading[src]) return loading[src];
    loading[src] = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () {
        resolve();
      };
      s.onerror = function () {
        delete loading[src];
        reject(new Error('Failed to load ' + src));
      };
      document.head.appendChild(s);
    });
    return loading[src];
  };

  /**
   * Idle callback polyfill for scheduling non-critical work.
   */
  Horizon.idle = function (fn, timeout) {
    if ('requestIdleCallback' in window) {
      return window.requestIdleCallback(fn, { timeout: timeout || 2000 });
    }
    return window.setTimeout(fn, 1);
  };

  // Shared visually-hidden live region. Clearing before the re-set is what
  // makes an identical repeat message announce again.
  var live;
  Horizon.announce = function (message) {
    if (!message || !document.body) return;
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    window.setTimeout(function () {
      live.textContent = message;
    }, 50);
  };

  Horizon.ready(function () {
    if (window.HorizonThumbHash && typeof window.HorizonThumbHash.enhanceImages === 'function') {
      window.HorizonThumbHash.enhanceImages(document);
    }

    // Lazy bridge: elements with data-h4-load-on="visible|interaction"
    document.querySelectorAll('[data-h4-script]').forEach(function (el) {
      var src = el.getAttribute('data-h4-script');
      var mode = el.getAttribute('data-h4-load-on') || 'visible';
      if (!src) return;

      var load = function () {
        Horizon.loadScript(src).catch(function () {});
      };

      if (mode === 'interaction') {
        var events = ['pointerdown', 'focusin', 'keydown'];
        var once = function () {
          events.forEach(function (e) {
            el.removeEventListener(e, once);
          });
          load();
        };
        events.forEach(function (e) {
          el.addEventListener(e, once, { passive: true });
        });
      } else if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                io.disconnect();
                load();
              }
            });
          },
          { rootMargin: '200px' }
        );
        io.observe(el);
      } else {
        Horizon.idle(load);
      }
    });
  });
})();
